<script lang="ts">
	import { faviconCdnUrl } from "./favicon";

	let { faviconSlug }: { faviconSlug: string } = $props();
</script>

<link rel="icon" href={faviconCdnUrl(faviconSlug, "/favicon.ico")} sizes="any" />
<link
	rel="icon"
	href={faviconCdnUrl(faviconSlug, "/favicon-32x32.png")}
	type="image/png"
	sizes="32x32"
/>
<link
	rel="icon"
	href={faviconCdnUrl(faviconSlug, "/favicon-16x16.png")}
	type="image/png"
	sizes="16x16"
/>
<link
	rel="apple-touch-icon"
	sizes="180x180"
	href={faviconCdnUrl(faviconSlug, "/apple-touch-icon.png")}
/>
<link rel="manifest" href="/site.webmanifest" />
